export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "2d73881294msha1715399ce3c38bp1d5432jsnff9c0daef6d6",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "d4155a272c26902e6f74c3e5d5ee8b13";

